/**
 * Validates exam-form deep-link query params (aligned with FormView exam mode).
 */
export function isNonEmptyExamQueryValue(value: string | null | undefined): boolean {
  if (!value) return false;
  const trimmed = value.trim();
  return trimmed.length > 0 && trimmed !== 'null' && trimmed !== 'undefined';
}

/** Both eid and efid must be present and non-placeholder for a valid exam form URL. */
export function hasCompleteExamFormQuery(searchParams: URLSearchParams): boolean {
  return (
    isNonEmptyExamQueryValue(searchParams.get('eid')) &&
    isNonEmptyExamQueryValue(searchParams.get('efid'))
  );
}

/**
 * Route gate for `/examform`: requires `eid` and `efid` query params.
 */
export function queryAllowsExamFormRouteEntry(searchParams: URLSearchParams): boolean {
  return hasCompleteExamFormQuery(searchParams);
}

/** `App` route path for deep-linked exam form — keep in sync with `<Route path="/examform" />`. */
export const EXAM_FORM_ROUTE_PATH = '/examform';

export function isExamFormRoutePath(pathname: string): boolean {
  return pathname === EXAM_FORM_ROUTE_PATH;
}

/**
 * Prefix for exam workspace routes — keep in sync with `<Route path="/exam-workspace" />` and
 * optional legacy `<Route path="/exam-workspace/:examId" />`.
 * Used for documentation / guards; matching is prefix-based (`/exam-workspace/123`).
 */
export const EXAM_WORKSPACE_ROUTE_PREFIX = '/exam-workspace';

export function isExamWorkspaceRoutePath(pathname: string): boolean {
  const p = pathname.trim();
  return p === EXAM_WORKSPACE_ROUTE_PREFIX || p.startsWith(`${EXAM_WORKSPACE_ROUTE_PREFIX}/`);
}
